module.exports = __webpack_public_path__ + "static/media/beep_error.4e2d89ba.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/audio/beep_error.ogg
// module id = 388
// module chunks = 0